export const enum MedicalCaseEvents {
    MedicalCaseReferralsUpdated = 'MedicalCaseReferralsUpdated',
    MedicalCaseOutwardReferralsUpdated = 'MedicalCaseOutwardReferralsUpdated',
    MedicalCaseRecommendationsUpdated = 'MedicalCaseRecommendationsUpdated',
    MedicalCaseTasksUpdated = 'MedicalCaseTasksUpdated',
    MedicalCaseDrugsUpdated = 'MedicalCaseDrugsUpdated',
    MedicalCaseDeleted = 'MedicalCaseDeleted',
}

interface MedicalCaseEventData<Body = {}> {
    body: Body;
    name: MedicalCaseEvents;
    entityId: string;
    entityType: 'MedicalCase';
    occurredOn: string;
}

export interface MedicalCaseReferralsUpdatedEventData extends MedicalCaseEventData<{ referralIds: string[] }> {}
export interface MedicalCaseOutwardReferralsUpdatedEventData
    extends MedicalCaseEventData<{ outwardReferralIds: string[] }> {}
export interface MedicalCaseRecommendationsUpdatedEventData
    extends MedicalCaseEventData<{ recommendationIds: string[] }> {}
export interface MedicalCaseTasksUpdatedEventData extends MedicalCaseEventData<{ taskIds: string[] }> {}
export interface MedicalCaseDrugsUpdatedEventData extends MedicalCaseEventData<{ drugIds: string[] }> {}
export interface MedicalCaseDeletedEventData
    extends MedicalCaseEventData<{
        referralIds?: string[];
        outwardReferralIds?: string[];
        drugIds?: string[];
        recommendationIds?: string[];
        taskIds?: string[];
    }> {}
